/**
 * Forma de `INVOICE_PAYMENT_ACTION` (billing/docs/specs/invoice-payment-action.schema.json) e os
 * rótulos da tela de parâmetros (AF-4126).
 */
import { OptionProps } from '../../../molecules/SelectTextField';

export const REFERENCES = ['INSTALLMENT', 'RECEIVABLE', 'GUARANTEE'];
export const SOURCES = ['SACADO', 'EMITENTE', 'AVALISTA'];
export const TOTAL = 'default_value_when:TOTAL';
export const PARTIAL = 'default_value_when:PARTIAL';

export interface ActionPair {
    [TOTAL]: { parent: string | null };
    [PARTIAL]: { parent: string | null; residual: string };
}

export type InvoicePaymentAction = Record<string, Record<string, any>>;

export const referenceKey = (reference: string) => `business_reference:${reference}`;
export const sourceKey = (source: string) => `payment_source:${source}`;

export const CONTROLS_OPTIONS: OptionProps[] = [
    { value: 'PROMISE', label: 'Na identificação' },
    { value: 'ON_APPROVE', label: 'Na efetivação' },
    { value: 'PROMISE_AND_ON_APPROVE', label: 'Na identificação e na Efetivação' },
    { value: 'HIDDEN_AND_PROMISE', label: 'Na identificação, caso precisar' },
    { value: 'HIDDEN_AND_ON_APPROVE', label: 'Na efetivação, caso precisar' },
];

export const PARENT_OPTIONS: OptionProps[] = [
    { value: 'CANCEL', label: 'Cancelar' },
    { value: 'UNCOLLECT', label: 'Deixar de cobrar' },
    { value: 'KEEP', label: 'Manter como está' },
];

export const RESIDUAL_MODE_OPTIONS: OptionProps[] = [
    { value: 'NONE', label: 'Não' },
    { value: 'MANUAL', label: 'Sim, Manual' },
    { value: 'AUTO', label: 'Sim, Automático' },
];

export const pairOf = (action: InvoicePaymentAction, reference: string, source: string): ActionPair =>
    action[referenceKey(reference)]?.[sourceKey(source)];

export const withPair = (
    action: InvoicePaymentAction, reference: string, source: string, pair: ActionPair,
): InvoicePaymentAction => ({
    ...action,
    [referenceKey(reference)]: { ...action[referenceKey(reference)], [sourceKey(source)]: pair },
});

export const withControls = (action: InvoicePaymentAction, reference: string, controls: string): InvoicePaymentAction => ({
    ...action,
    [referenceKey(reference)]: { ...action[referenceKey(reference)], controls },
});

export const parentLabel = (parent: string | null) => parent ?? '—';
